import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection};
  justify-content: flex-start;
  padding-right: ${props => props.paddingRight && '8px'};
  width: ${props => props.width};
  @media only screen and (max-width: 850px) {
    width: ${props => !props.noMobileWidth && '100%'};
  }
`;

export default Container;
